import { createSlice, current } from '@reduxjs/toolkit';
import {
	getWaterUseTypeList,
	getWaterUseType,
	addNewWaterUseType,
	updateWaterUseType,
	deleteWaterUseType,
	checkWaterUseTypeExists,
} from './thunk';

export const initialState = {
	itemWaterUseTypeList: [],
	itemWaterUseType: null,
	isWaterUseTypeLoading: false,
	isWaterUseTypeSuccess: false,
	dataWaterUseType: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const WaterUseTypeSlice = createSlice({
	name: 'WaterUseType',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getWaterUseTypeList.pending, state => {
			state.isLoadingList = true;
			state.isWaterUseTypeSuccess = false;
		});

		builder.addCase(getWaterUseTypeList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemWaterUseTypeList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isWaterUseTypeSuccess = true;
		});

		builder.addCase(getWaterUseTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWaterUseTypeSuccess = false;
		});

		builder.addCase(getWaterUseType.pending, state => {
			state.isWaterUseTypeLoading = true;
			state.isWaterUseTypeSuccess = false;
		});

		builder.addCase(getWaterUseType.fulfilled, (state, action) => {
			state.itemWaterUseType = action.payload;
			state.isWaterUseTypeLoading = false;
			state.isWaterUseTypeSuccess = true;
		});

		builder.addCase(getWaterUseType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isWaterUseTypeLoading = false;
			state.isWaterUseTypeSuccess = false;
		});

		builder.addCase(addNewWaterUseType.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewWaterUseType.fulfilled, (state, action) => {
			state.itemWaterUseTypeList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewWaterUseType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateWaterUseType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateWaterUseType.fulfilled, (state, action) => {
			state.itemWaterUseTypeList = state.itemWaterUseTypeList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementList = state.statementList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? { item: action.payload, value: action.payload._id, label: action.payload.name }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(updateWaterUseType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWaterUseType.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteWaterUseType.fulfilled, (state, action) => {
			state.itemWaterUseTypeList = current(state.itemWaterUseTypeList).filter(
				item => item._id.toString() !== action.payload._id.toString()
			);
			state.statementList = current(state.statementList).filter(
				item => item._id.toString() !== action.payload._id.toString()
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value.toString() !== action.payload._id.toString()
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDeleteError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteWaterUseType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkWaterUseTypeExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkWaterUseTypeExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkWaterUseTypeExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = WaterUseTypeSlice.actions;

export default WaterUseTypeSlice.reducer;
